import sendConventionApiRequest from "lib/send-convention-api-request"
import { Current } from "lib/use-current"

interface DeleteConventionMeetingRegistrationParameters {
  current: Current
  id: string
}

export default async function deleteConventionMeetingRegistration(
  parameters: DeleteConventionMeetingRegistrationParameters,
) {
  const { current, id } = parameters

  const providerId = current.provider?.id
  if (!providerId) throw "providerId is not defined"
  if (!id) throw "id is not defined"

  await sendConventionApiRequest({
    current,
    method: "DELETE",
    url: `v1/convention_providers/${providerId}/convention_meeting_registrations/${id}`,
  })
}
